
import { defineComponent, reactive } from 'vue'
import Email from '@/email'
export default defineComponent({
  name: 'Form',
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  setup () {
    let form = reactive({
      name: '',
      birth: '',
      trade: '',
      email: '',
      phone: '',
      funding: false,
      message: ''
    })
    return { form }
  },
  methods: {
    submit (): void {
      if (this.form !== undefined) {
        Email.send(this.form)
      }
      if (process.env.NODE_ENV !== 'production') {
        console.log('Sending form data...')
      }
    }
  }
})
